import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEventRdtResult = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	height: 32,
	viewBox: "0 0 32 32",
	width: 32,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		stroke: "currentColor",
		strokeWidth: 1.8,
		children: [
			/* @__PURE__ */ _jsx("rect", {
				height: 24.8667,
				rx: 3.1,
				width: 12.8667,
				x: 8.9,
				y: 3.56699
			}),
			/* @__PURE__ */ _jsx("rect", {
				height: 7.53333,
				rx: 1.1,
				width: 4.86667,
				x: 12.9,
				y: 7.67344
			}),
			/* @__PURE__ */ _jsx("rect", {
				height: 5.37949,
				rx: 1.76667,
				width: 3.53333,
				x: 13.566,
				y: 18.9391
			})
		]
	})
});
export default SvgEventRdtResult;
